import { useStaticQuery, graphql } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            url
            siteURL
            twitter
          }
        }
      }
    `,
  );
  return site.siteMetadata;
};

export default useSiteMetadata;
